module.exports = __webpack_public_path__ + "media/newstyle/images/img-footer-981fee3d70569cd1e575ae8a4790c034.svg";